// extracted by mini-css-extract-plugin
export default {"root":"OccasionIcon_root__Mu7kV","icon":"OccasionIcon_icon__zaA+5","hidden":"OccasionIcon_hidden__ZdYi4"};